import React, { useContext } from 'react';
import { connect as formikConnect, getIn, FormikContext as FormikContextT } from 'formik';
import { AutocompleteValue, AutocompleteChangeReason } from '@mui/material';
import AutocompleteBase, { AutocompleteBaseProps } from './AutocompleteBase';

const FormikContext = React.createContext<FormikContextT<object> | null>(null);

const useFormikContext = () => useContext(FormikContext)!;

//TODO: Migrate to formik v2 and  remove custom fromik provider after, use useFormikContext from lib [https://over-haul.atlassian.net/browse/OK-37910]
export const FormikProdiver = formikConnect(({ formik, children }: any) => {
  return <FormikContext.Provider value={formik}>
    {children}
  </FormikContext.Provider>;
});

export const withFormikAutocompleteHandlers = (WrappedComponent: typeof AutocompleteBase) => {

  const Component = <
    T,
    Multiple extends boolean | undefined = false,
    DisableClearable extends boolean | undefined = false,
    FreeSolo extends boolean | undefined = false>({ disableDefaultFormikSetValue, ...props }
      : AutocompleteBaseProps<T, Multiple, DisableClearable, FreeSolo> & { disableDefaultFormikSetValue?: boolean }) => {

    const formik = useFormikContext();

    const handleChange = (
      e: React.SyntheticEvent,
      newValue: AutocompleteValue<T, Multiple, DisableClearable, FreeSolo>,
      reason: AutocompleteChangeReason
    ) => {
      !disableDefaultFormikSetValue && formik.setFieldValue(props.name, newValue);
      props.onChange && props.onChange(e, newValue, reason);
    };

    const handleBlur = (e: React.FocusEvent<HTMLDivElement, Element>) => {
      formik.setFieldTouched(props.name, true);
      props.onBlur && props.onBlur(e);
    };

    const handleClear = () => {
      formik.setFieldValue(props.name, props.multiple ? [] : null);
      formik.setFieldTouched(props.name, true);
      props.onClear && props.onClear();
    };

    const error: any = getIn(formik.errors, props.name);
    const touched: boolean = getIn(formik.touched, props.name);
    const value: AutocompleteValue<T, Multiple, DisableClearable, FreeSolo> = getIn(formik.values, props.name);

    return (
      <WrappedComponent
        {...props}
        error={!!(touched && error)}
        helperText={touched && error || props.helperText}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onClear={handleClear}
      />
    );
  };

  //TODO: Migrate to formik v2 and  remove formik Wrapper, use useFormikContext from lib [https://over-haul.atlassian.net/browse/OK-37910]
  const FormikWrapper = <
    T,
    Multiple extends boolean | undefined = false,
    DisableClearable extends boolean | undefined = false,
    FreeSolo extends boolean | undefined = false>(props:
      AutocompleteBaseProps<T, Multiple, DisableClearable, FreeSolo> & { disableDefaultFormikSetValue?: boolean }) => {
    return <FormikProdiver>{<Component {...props} />}</FormikProdiver>;
  };
  return FormikWrapper;
};

export default withFormikAutocompleteHandlers(AutocompleteBase);